<template>
	<div class="app-main">
		<div style="padding-bottom: 5px;display: flex;align-items: center;">
			<el-divider direction="vertical"></el-divider>
			<span>开票信息</span>
		</div>
		<div style="padding-bottom: 5px;">
			<el-alert description="非常重要: 开票信息要保证发票真实有效，请维护准确完整的开票信息。">
			</el-alert>
		</div>
		<el-form label-width="120px" ref="form" :disabled="preview" :model="form" :rules="rules" size="small">
			<el-row>
				<el-col :span="12">
					<el-form-item label="发票头" prop="invoiceHead">
						<el-input v-model="form.invoiceHead" placeholder="请输入发票头" />
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="税务登记号" prop="swDjh">
						<el-input v-model="form.swDjh" placeholder="请输入税务登记号" />
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="开户行" prop="khhName">
						<el-input v-model="form.khhName" placeholder="请输入开户行" />
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="开户行账号" prop="khhNumber">
						<el-input v-model="form.khhNumber" placeholder="请输入开户行账号" />
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="税务登记地址" prop="swDjDz">
						<el-input v-model="form.swDjDz" placeholder="请输入税务登记地址" />
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="税务登记电话" prop="swDjDh">
						<el-input v-model="form.swDjDh" placeholder="请输入税务登记电话" />
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="收票人邮箱" prop="sprEmail">
						<el-input v-model="form.sprEmail" placeholder="请输入收票人邮箱" />
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="收票人电话" prop="sprDh">
						<el-input v-model="form.sprDh" placeholder="请输入收票人电话" />
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
		<div v-if="!preview" style="text-align: center;">
			<span slot="footer" class="dialog-footer">
				<el-button @click="submitForm(5)" size="small">上一步</el-button>
				<el-button type="primary" @click="submitForm(7)" size="small">下一步</el-button>
			</span>
		</div>

	</div>
</template>

<script>
	import {
		supplierInfoById,
		addSupplierInfo,
		editSupplierInfo,
		delSupplierInfo,
	} from '@/api/gys/supplierInfo.js'
	import {
		supplierBankIdList
	} from '@/api/gys/supplierBankId.js'
	import{addSupplierApprovalMx, getSupplierApprovalMx} from '@/api/gys/supplierInfo.js'
	export default {
		name: "InvoiceInfo",
		computed: {},
		props: {
			basicId: {
				type: Number,
			},
			preview: {
				type: Boolean,
				default: false
			},
			otherInfo: {
				type: Object,
				default: {}
			}
		},
		data() {
			return {
				title: "",
				tableData: [],
				ids: [],
				form: {
					invoiceHead: undefined,
					swDjh: undefined,
					khhName: undefined,
					khhNumber: undefined,
					swDjDz: undefined,
					swDjDh: undefined,
					sprEmail: undefined,
					sprDh: undefined,
				},
				loadingInstance: undefined,
				// bankList: [],
				quertInfo: {
					page: 1, //当前页码
					limit: 20, //当前每页显示的数量
					searchTime: [],
					objMap: {
						search: '',
						hId: this.basicId,
					}
				},
				rules: {
					invoiceHead: [{
						required: true,
						message: '请输入发票头',
						trigger: 'blur'
					}],
					swDjh: [{
						required: true,
						message: '请输入税务登记号',
						trigger: 'blur'
					}],
					khhName: [{
						required: true,
						message: '请输入开户行',
						trigger: 'blur'
					}],
					khhNumber: [{
						required: true,
						message: '请输入开户行账号',
						trigger: 'blur'
					}],
					// swDjDz: [{
					// 	required: true,
					// 	message: '请输入税务登记地址',
					// 	trigger: 'blur'
					// }],
					// swDjDh: [{
					// 	required: true,
					// 	message: '请输入税务登记电话',
					// 	trigger: 'blur'
					// }],
					// sprEmail: [{
					// 		required: true,
					// 		message: '请输入收票人邮箱',
					// 		trigger: 'blur'
					// 	},
					// 	{
					// 		pattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
					// 		message: "邮箱格式不正确",
					// 		trigger: "blur"
					// 	}
					// ],
					// sprDh: [{
					// 		required: true,
					// 		message: '请输入收票人电话',
					// 		trigger: 'blur'
					// 	},
					// 	{
					// 		pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
					// 		message: "请输入正确的手机号码",
					// 		trigger: "blur"
					// 	}
					// ],
				}
			};
		},
		created() {
			this.getList();
			// this.getSupplierBankIDList();
		},
		methods: {
			//查询银行信息
			// getSupplierBankIDList() {
			// 	let _this = this;
			// 	supplierBankIdList(_this.quertInfo).then(response => {
			// 		if (response.data.code === 0) {
			// 			_this.bankList = response.data.data;
			// 		}
			// 	});
			// },
			async getList() {
				let _this = this;
				let pramar = {
					classType:'com.srm.entity.SupplierInfo',
					classTypeIndex:'2',
					supplierInfoId:_this.basicId,
				};
				if(this.otherInfo.lastPass){
					pramar['queryType']='lastPass'
				}
				const { data: res } = await getSupplierApprovalMx(pramar)
				if (res.code == 0) {
					if(res.data && res.data.jsonData){
						let JsonInfo = JSON.parse(res.data.jsonData);
						_this.form = {
							invoiceHead: JsonInfo.invoiceHead||undefined,
							swDjh: JsonInfo.swDjh||undefined,
							khhName: JsonInfo.khhName||undefined,
							khhNumber: JsonInfo.khhNumber||undefined,
							swDjDz: JsonInfo.swDjDz||undefined,
							swDjDh: JsonInfo.swDjDh||undefined,
							sprEmail: JsonInfo.sprEmail||undefined,
							sprDh: JsonInfo.sprDh||undefined,
						};
					}
				}
			},
			// 表单重置
			reset: function() {
				this.form = {
					invoiceHead: undefined,
					swDjh: undefined,
					khhName: undefined,
					khhNumber: undefined,
					swDjDz: undefined,
					swDjDh: undefined,
					sprEmail: undefined,
					sprDh: undefined,
				}
				if (this.$refs["form"] !== undefined) {
					this.$refs["form"].resetFields();
				}
			},
			submitForm(stemp) {
				let _this = this;
				_this.$refs['form'].validate((valid) => {
					if (valid) {
						addSupplierApprovalMx({
							classType:'com.srm.entity.SupplierInfo',
							classTypeIndex:'2',
							supplierInfoId:_this.basicId,
							jsonData:JSON.stringify(_this.form)
						}).then(response => {
							if (response.data.code === 0) {
								_this.bus.$emit('stepsFun', stemp);
							} else {
								_this.$fail(response.data.msg);
							}
						});
					}
				});
			},
			handleAdd: function() {
				this.reset();
				this.title = "新增";
				this.openDialog = true;
			},
			handleEdit: function(row) {
				this.reset();
				this.title = "修改";
				this.form = JSON.parse(JSON.stringify(row)); //直接赋值 表格数据 也会改变 要深拷贝复制
				this.openDialog = true;
			},
			//上一步
			backStep: function() {
				this.bus.$emit('stepsFun', 5);
			},
			handleDel: function(id) {
				let _this = this;
				_this.confirm({
					text: '确认删除吗',
					tip: '警告',
					type: '',
					fn: function(param) {
						delSupplierInfo(param).then(response => {
							if (response.data.code === 0) {
								_this.$success(response.data.msg);
								_this.getList();
							} else {
								_this.$fail(response.data.msg);
							}
						});
					},
					data: {
						id: id
					} //参数对象 主要回调函数用
				});
			},
			bankOption: function(item) {
				this.$set(this.form, "khhNumber", item.bankNumber)
			}
		}
	};
</script>
<style scoped="scoped">
	/**
        * 全屏弹框 不滚动
        */
	.el-dialog__wrapper {
		overflow: hidden;
	}

	.newDialog ::v-deep .el-dialog__body {
		overflow: auto;
		height: calc(100vh - 90px);
		/*头+padding10 +加尾+padding10 + 2px 边框*/
	}
</style>
